let nextId = 1;

function createNotification(notification) {
  return {
    ...notification,
    id: nextId++,
  };
}

// If notification family is same then it will replace previous member
function createOrUpdateNotification(state, notification) {
  const duplicateFamilyIdx = notification.family ? state.notifications.findIndex(n => n.family === notification.family) : -1;

  // If override duplicate is false then we ignore new notification with same family name
  if (duplicateFamilyIdx !== -1 && notification.overrideDuplicate === false) {
    return;
  }

  const newNotification = createNotification(notification);

  if (duplicateFamilyIdx === -1) {
    state.notifications.push(newNotification);
  } else {
    state.notifications[duplicateFamilyIdx] = newNotification;
  }
}

export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  mutations: {
    PUSH(state, notification) {
      createOrUpdateNotification(state, notification);
    },
    DELETE(state, notificationId) {
      state.notifications = state.notifications.filter(notification => notification.id !== notificationId);
    },
  },
  actions: {
    add({ commit }, notification) {
      commit('PUSH', notification);
    },
    remove({ commit }, notificationId) {
      commit('DELETE', notificationId);
    },
    notifySuccess({ commit }, { message, options }) {
      commit('PUSH', {
        type: 'success',
        text: { class: 'text-secondary font-weight-bold' },
        icon: {
          icon: ['fal', 'check-circle'],
          size: 'lg',
          class: 'mr-2',
        },
        message,
        ...options,
      });
    },
    notifyFailure({ commit }, { message, options }) {
      commit('PUSH', {
        type: 'danger',
        text: { class: 'font-weight-bold' },
        icon: {
          icon: ['far', 'times-circle'],
          size: 'lg',
          class: 'mr-2',
        },
        message,
        ...options,
      });
    },
  },
  getters: {
    notifications: state => state.notifications,
    hasNotifications: state => state.notifications.length > 0,
  },
};
